
import { Component, Injector, Input, OnInit } from '@angular/core';
import {
	ComponentContextService, DataFormBase, EventData, FormSchemaBase, TextControlSchema,
	SwitchControlSchema, DateTimeControlSchema
} from 'tnx-shared';
import { EventService } from 'tnx-admin-service/workflowcore/event/services';

@Component({
	selector: 'event-form',
	templateUrl: './event-form.component.html',
	styleUrls: ['./event-form.component.scss'],
	providers: [ComponentContextService],
})
export class EventFormComponent extends DataFormBase implements OnInit {

	constructor(
		protected _injector: Injector,
		private _eventService: EventService
	) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.setting.baseService = this._eventService;
		this.setting.schema = <FormSchemaBase[]>[
			new TextControlSchema({
				field: 'persistenceId',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventData',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventId',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventKey',
				label: ''
			}),
			new TextControlSchema({
				field: 'eventName',
				label: ''
			}),
			new DateTimeControlSchema({
				field: 'eventTime',
				label: ''
			}),
			new SwitchControlSchema({
				field: 'isProcessed',
				label: ''
			}),
			new TextControlSchema({
				field: 'currentStateCode',
				label: ''
			}),
			new TextControlSchema({
				field: 'code',
				label: ''
			})
		];
	}

	async onFormInitialized(formEvent: EventData) {
		// tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
	}

	async onFormEvent(evt) {
		// các event trong form
		console.log(evt);
	}

	async modifyDetailData(data) {
		// xử lý dữ liệu lấy từ get detail về
	}

	async onAfterGetDetail() {
		// xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
	}

	onBeforeSave() {
		// trước khi lưu
	}
}

